function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Form, Table, Button, Space, Drawer, Modal, message, List, Tag, notification } from 'antd';
import Moment from 'react-moment';
import AddSettlement from './forms/AddSettlement';
import AddDeliveryReport from './forms/AddDeliveryReport';
import OrderDetailsView from './OrderDetailsView';
import { ThreeDots, CheckCircleFill, ClockHistory, Truck, BoxFill } from 'react-bootstrap-icons';
import Common from './includes/Common';
import AddProviderPurchaseOrderSettlement from './forms/AddProviderPurchaseOrderSettlement';
import AddPurchaseOrderDeliveryReport from './forms/AddPurchaseOrderDeliveryReport';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OrderListView = function OrderListView(_ref) {
  var orderList = _ref.orderList,
    dataRefreshHandler = _ref.dataRefreshHandler,
    loading = _ref.loading;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    orderArrayData = _useState4[0],
    setOrderArrayData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPaymentVisible = _useState6[0],
    setIsPaymentVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDeliveryVisible = _useState8[0],
    setIsDeliveryVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isOrderDetailsVisible = _useState0[0],
    setIsOrderDetailsVisible = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedOrder = _useState10[0],
    setSelectedOrder = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleOrderValidate = function handleOrderValidate(order) {
    setSelectedOrder(order);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmer la cr\xE9ation de la commande?"
      }),
      content: /*#__PURE__*/_jsxs("div", {
        style: {
          marginTop: "8px",
          padding: "6px",
          border: "1px dashed #528F69",
          borderRadius: "8px"
        },
        children: [/*#__PURE__*/_jsx("h6", {
          children: /*#__PURE__*/_jsxs("b", {
            children: ["R\xE9sum\xE9 commande - ", order.provider.label]
          })
        }), /*#__PURE__*/_jsx(List, {
          dataSource: order.provider_purchase_order_items,
          itemLayout: "vertical",
          size: "small",
          renderItem: function renderItem(item, index) {
            return /*#__PURE__*/_jsx(List.Item, {
              actions: [],
              children: /*#__PURE__*/_jsx(List.Item.Meta, {
                avatar: /*#__PURE__*/_jsx(BoxFill, {
                  size: 15
                }),
                title: item.label,
                description: /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "Prix: "
                    }), item.price.toLocaleString("Fr")]
                  }), /*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: " Qte: "
                    }), item.quantity]
                  }), " "]
                })
              })
            });
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h6", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "TOTAL : "
          }), order.total_amount.toLocaleString("Fr")]
        })]
      }),
      type: "info",
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "validatepurchaseorder", {
          provider_purchase_order_id: order.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            dataRefreshHandler();
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      },
      okText: "Confirmer",
      cancelText: "Annuler"
    });
  };
  var handleOrderInvalidate = function handleOrderInvalidate(order) {
    setSelectedOrder(order);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmer l'annulation de la commande?"
      }),
      content: /*#__PURE__*/_jsxs("div", {
        style: {
          marginTop: "8px",
          padding: "6px",
          border: "1px dashed #528F69",
          borderRadius: "8px"
        },
        children: [/*#__PURE__*/_jsx("h6", {
          children: /*#__PURE__*/_jsxs("b", {
            children: ["Annulation - ", order.provider.label]
          })
        }), /*#__PURE__*/_jsx(List, {
          dataSource: order.provider_purchase_order_items,
          itemLayout: "vertical",
          size: "small",
          renderItem: function renderItem(item, index) {
            return /*#__PURE__*/_jsx(List.Item, {
              actions: [],
              children: /*#__PURE__*/_jsx(List.Item.Meta, {
                avatar: /*#__PURE__*/_jsx(BoxFill, {
                  size: 15
                }),
                title: item.label,
                description: /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "Prix: "
                    }), item.price.toLocaleString("Fr")]
                  }), /*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: " Qte: "
                    }), item.quantity]
                  }), " "]
                })
              })
            });
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h6", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "TOTAL : "
          }), order.total_amount.toLocaleString("Fr")]
        })]
      }),
      type: "error",
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "invalidateorder", {
          provider_purchase_order_id: order.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            message.success({
              content: response.data.message,
              delay: 4
            });
            dataRefreshHandler();
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        })["finally"](function () {});
      },
      okText: "Confirmer annulation",
      cancelText: "Quitter"
    });
  };
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "PDV"
    }),
    dataIndex: "pos",
    render: function render(v) {
      return /*#__PURE__*/_jsx(Tag, {
        color: "default",
        children: v
      });
    },
    key: "pos"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Fourn."
    }),
    dataIndex: 'provider',
    key: 'provider',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Total (GNF)"
    }),
    dataIndex: 'amount',
    responsive: ['lg', 'md', 'sm'],
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Pay\xE9 (GNF)"
    }),
    dataIndex: 'paid_amount',
    key: 'paid_amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Restant (GNF)"
    }),
    responsive: ['lg', 'md', 'sm'],
    dataIndex: 'rest_amount',
    key: 'rest_amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Status"
    }),
    responsive: ['lg', 'md', 'sm'],
    dataIndex: 'status',
    key: 'status',
    render: function render(status) {
      return /*#__PURE__*/_jsxs("div", {
        children: [status == 0 && /*#__PURE__*/_jsx(ClockHistory, {
          style: {
            color: '#ED8042'
          },
          size: 18
        }), status == 1 && /*#__PURE__*/_jsx(CheckCircleFill, {
          style: {
            color: '#85D58C'
          },
          size: 18
        }), status == 2 && /*#__PURE__*/_jsx(Truck, {
          style: {
            color: '#0C4AA6'
          },
          size: 18
        })]
      });
    }
  }, {
    title: '',
    dataIndex: 'order',
    key: 'order',
    render: function render(order) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          disabled: order.status == 0 || order.status == 2,
          onClick: function onClick() {
            setSelectedOrder(order);
            setIsDeliveryVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "LIVRER"
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          disabled: order.status == 0 || order.status > 4,
          onClick: function onClick() {
            setSelectedOrder(order);
            setIsPaymentVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "PAYER"
          })
        }), order.status == 0 && /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "link",
            style: {
              color: '#85D58C'
            },
            onClick: function onClick() {
              handleOrderValidate(order);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "VALIDER"
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "link",
            style: {
              color: '#F27878'
            },
            onClick: function onClick() {
              handleOrderInvalidate(order);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "ANNULER"
            })
          })]
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedOrder(order);
            setIsOrderDetailsVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(ThreeDots, {
              size: 25
            })
          })
        })]
      });
    }
  }];
  useEffect(function () {
    setOrderArrayData([]);
    orderList.forEach(function (o) {
      setOrderArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: o.id,
          provider: o.provider.label,
          amount: o.total_amount,
          paid_amount: o.paid_amount,
          pos: o.point_of_sale && o.point_of_sale.label,
          rest_amount: o.total_amount - o.paid_amount,
          status: o.status,
          date: o.created_at,
          order: o
        }]);
      });
    });
  }, [orderList, isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h6", {
      children: /*#__PURE__*/_jsx("b", {
        children: "TABLEAU DES COMMANDES"
      })
    }), ContextHolder, /*#__PURE__*/_jsx(Table, {
      bordered: true,
      columns: cols,
      size: "small",
      loading: loading,
      dataSource: orderArrayData
    }), selectedOrder != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "FAIRE UN PAIEMENT"
        }),
        width: "400px",
        destroyOnClose: true,
        open: isPaymentVisible,
        onClose: function onClose() {
          setIsPaymentVisible(false);
        },
        children: /*#__PURE__*/_jsx(AddProviderPurchaseOrderSettlement, {
          order: selectedOrder,
          handler: function handler() {
            setIsDataChanged(true);
            dataRefreshHandler();
            message.success({
              content: 'Opération reussie !'
            });
            setIsPaymentVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "FAIRE UNE LIVRAISON"
        }),
        width: "440px",
        destroyOnClose: true,
        open: isDeliveryVisible,
        onClose: function onClose() {
          setIsDeliveryVisible(false);
        },
        children: /*#__PURE__*/_jsx(AddPurchaseOrderDeliveryReport, {
          order: selectedOrder,
          handler: function handler() {
            setIsDataChanged(true);
            dataRefreshHandler();
            message.success({
              content: 'Opération reussie !'
            });
            setIsDeliveryVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(Truck, {
            size: 24,
            color: "#0C4AA5"
          }), " DETAILS COMMANDE"]
        }),
        width: "95%",
        destroyOnClose: true,
        open: isOrderDetailsVisible,
        footer: null,
        onCancel: function onCancel() {
          setIsOrderDetailsVisible(false);
        },
        children: /*#__PURE__*/_jsx(OrderDetailsView, {
          order: selectedOrder
        })
      })]
    })]
  });
};
export default OrderListView;